<template>
  <!-- 客户/供应商-信息摘要 -->
  <a-modal
    title="信息摘要"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="50%"
    :footer="null"
    @cancel="close"
  >
    <a-row :gutter="16">
      <a-col :span="6" v-for="(item, index) in dataTitleList" :key="index" style="margin-bottom: 20px;">
        <div class="summary-item">
          <div class="summary-item-value">
            <span class="qian">¥</span>
            <span class="amount">
              <a-tooltip>
                <template slot="title">
                  {{ parseFloat(item.value).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} 元
                </template>
                {{ formatAmount(item.value) }}
              </a-tooltip>
            </span>
            <!-- <span class="amount">
              <span>{{ amountVal(item.value).first }}</span>
              <span>{{ amountVal(item.value).last && amountVal(item.value).last !== '万' ? '.' : '' }}{{ amountVal(item.value).last }}</span></span> -->
          </div>
          <div class="summary-item-text">{{item.title}}</div>
        </div>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { removeZero } from '@/utils'
import { formatAmount } from '@/utils/common'

export default {
  name: 'Message',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataTitleList: [],
      customerData: [
        {
          title: '合同单总额',
          value: ''
        },
        {
          title: '合同单未回款额',
          value: ''
        },
        {
          title: '回款总金额',
          value: ''
        },
        {
          title: '回款冲销金额',
          value: ''
        },
        {
          title: '已开票金额',
          value: ''
        },
        {
          title: '费用报销',
          value: ''
        },
        {
          title: '毛利润',
          value: ''
        }
      ],
      supplierData: [
        {
          title: '采购总金额',
          value: ''
        },
        {
          title: '付款总额',
          value: ''
        },
        {
          title: '采购已冲销总额',
          value: ''
        },
        {
          title: '采购未付款额',
          value: ''
        },
        {
          title: '付款发票总额',
          value: ''
        },
        {
          title: '费用报销',
          value: ''
        }
      ],
      followData: {}
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    }
  },
  methods: {
    formatAmount,
    setData (valType, data) {
      this.followData = data
      // valType 客户视图 1  供应商视图 2
      if (valType === 1) {
        this.dataTitleList = this.customerData
        this.getCustomerData()
      } else if (valType === 2) {
        this.dataTitleList = this.supplierData
        this.getSupplierData()
      }
    },
    getCustomerData () {
      // 合同单总额、合同未回款额、回款总金额、回款冲销金额、已开票金额、费用报销、毛利润
      this.customerData[0].value = this.followData.topInfo1st
      this.customerData[1].value = this.followData.topInfo2nd
      this.customerData[2].value = this.followData.topInfo3rd
      this.customerData[3].value = this.followData.backCxTotal
      this.customerData[4].value = this.followData.topInfo4th
      // 费用报销
      // this.customerData[5].value = this.countFy()
      this.customerData[5].value = this.followData.reimbursementTotal
      // 计算毛利润 所有合同的毛利grossProfit
      this.customerData[6].value = this.followData.projectProfit
      /* if (this.followData.contractList && this.followData.contractList.length > 0) {
        let grossProfit = 0
        this.followData.contractList.forEach(item => {
          grossProfit += item.grossProfit
        })
        this.customerData[6].value = grossProfit
      } else {
        this.customerData[6].value = 0
      } */
    },
    getSupplierData () {
      // 采购总金额、付款总额、采购已冲销金额、采购未付款额、付款发票总额
      this.supplierData[0].value = this.followData.topInfo1st
      this.supplierData[1].value = this.followData.topInfo3rd
      this.supplierData[2].value = this.followData.topInfo3rd
      this.supplierData[3].value = this.followData.topInfo2nd
      this.supplierData[4].value = this.followData.topInfo4th
      // 费用报销
      this.supplierData[5].value = this.followData.reimbursementTotal
      // this.supplierData[5].value = this.countFy()
    },
    countFy () {
      if (this.followData.reimbursementList && this.followData.reimbursementList.length > 0) {
        let fybx = 0
        this.followData.reimbursementList.forEach(item => {
          fybx += item.amount
        })
        return fybx
      } else {
        return 0
      }
    },
    amountVal (itemVal) {
      var money = this.formatNumbers(itemVal)
      var arrObj = {
        first: '',
        last: ''
      }
      if (money.includes('.')) {
        var arr = money.split('.')
        arrObj.first = arr[0] ? arr[0] : arr[1]
        arrObj.last = arr[0] ? arr[1] : ''
      } else {
        arrObj.first = money.slice(0, -1)
        arrObj.last = money.slice(-1)
      }
      return arrObj
    },
    formatNumbers (num) {
      num = Number(num)
      if (num === 0 || (num > 0 && num < 10000)) {
        return num + '元'
      } else if (num < 0 && num > -10000) {
        return num + '元'
      } else {
        return removeZero((num / 10000).toFixed(4)) + '万'
      }
      /* else if (num >= 10000 && num < 100000000) {
        return removeZero((num / 10000).toFixed(2)) + '万'
      } else if (num >= 100000000) {
        return removeZero((num / 100000000).toFixed(2)) + '亿'
      } */
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  padding-bottom: 0;
  box-sizing: border-box;
  .ant-modal-content {
    min-height: auto;
  }
}
.summary-item {
  text-align: center;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #fafafa;
  .summary-item-value {
    font-size: 24px;
    font-weight: 600;
    color: #1890ff;
    font-size: 16px;

    .qian{
      /* font-size: 26px;
      font-weight: bold; */
    }
    .amount {
      font-size: 26px;
      font-weight: bold;
    }
  }
  .summary-item-text {
    font-size: 14px;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customerManage/message.vue